import { gql } from '@apollo/client';

export default gql`
  mutation RecordSignIn {
    recordSignIn {
      accepted
    }
  }
`;
